
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { getAllPosts } from '../../../lib/blog';
import BlogPage from '../index';
export async function getStaticPaths({ locales }) {
    const { pagination } = getAllPosts(locales[0]);
    const paths = [];
    for (const locale of locales) {
        for (let page = 2; page <= pagination.totalPages; page++) {
            paths.push({
                params: { page: page.toString() },
                locale
            });
        }
    }
    return {
        paths,
        fallback: false
    };
}
async function getStaticProps({ params, locale }) {
    const page = parseInt(params.page);
    const { posts, pagination } = getAllPosts(locale, page);
    return {
        props: {
            posts,
            pagination
        }
    };
}
export default BlogPage;

    async function __Next_Translate__getStaticProps__1a1723ec761__(ctx) {
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/page/[page]',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a1723ec761__ as getStaticProps }
  